export class PassStrengthEvaluator {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static loadingPromise: Promise<any>;
    static lib: (password: string) => {score: number};

    public static async libIsLoaded() {
        if (!this.loadingPromise) {
            // @ts-ignore
            this.loadingPromise = import('zxcvbn').then((lib) => {
                this.lib = lib.default;
            });
        }

        return this.loadingPromise;
    }

    public static evaluate(password: string): number {
        const res = PassStrengthEvaluator.lib(password);
        return res.score;
    }
}
